export default __webpack_public_path__ + "static/media/background3.f7b08fa8.svg";